const DB_NAME = "screen-recordings"
const STORE = "takes"

function openDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)
    request.onupgradeneeded = () => {
      request.result.createObjectStore(STORE, { keyPath: "localId" })
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

function withStore(mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, mode)
    const store = tx.objectStore(STORE)
    const request = fn(store)
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  }))
}

export function listTakes() {
  return withStore("readonly", (store) => store.getAll())
}

export function saveTake(take) {
  return withStore("readwrite", (store) => store.put(take))
}

export function deleteTakeRecord(localId) {
  return withStore("readwrite", (store) => store.delete(localId))
}

async function takesDirectory() {
  const root = await navigator.storage.getDirectory()
  return root.getDirectoryHandle("takes", { create: true })
}

export async function createTakeFile(localId) {
  const directory = await takesDirectory()
  const handle = await directory.getFileHandle(`${localId}.webm`, { create: true })
  const writable = await handle.createWritable()
  return writable
}

export async function readTakeFile(localId) {
  const directory = await takesDirectory()
  const handle = await directory.getFileHandle(`${localId}.webm`)
  return handle.getFile()
}

export async function deleteTakeFile(localId) {
  const directory = await takesDirectory()
  await directory.removeEntry(`${localId}.webm`)
}

export async function deleteTake(localId) {
  await deleteTakeRecord(localId).catch(() => {})
  await deleteTakeFile(localId).catch(() => {})
}
